import type { CapacityLevel } from "@/lib/capacityLevel";
import type { TranslationKey } from "@/i18n/translations";

// Capacity colours come from one source (src/lib/capacityColors.ts via the
// `capacity-*` tokens); the `-light` tokens are the light-theme values.
export const LEVEL_DOT: Record<CapacityLevel, string> = {
  GREEN: "bg-capacity-green light:bg-capacity-green-light",
  YELLOW: "bg-capacity-yellow light:bg-capacity-yellow-light",
  RED: "bg-capacity-red light:bg-capacity-red-light",
};

export const LEVEL_LABEL_KEY: Record<CapacityLevel, TranslationKey> = {
  GREEN: "LEVEL_GREEN",
  YELLOW: "LEVEL_YELLOW",
  RED: "LEVEL_RED",
};

export const LEVEL_TEXT: Record<CapacityLevel, string> = {
  GREEN: "text-capacity-green light:text-capacity-green-light",
  YELLOW: "text-capacity-yellow light:text-capacity-yellow-light",
  RED: "text-capacity-red light:text-capacity-red-light",
};

export const LEVEL_BORDER: Record<CapacityLevel, string> = {
  GREEN: "border-capacity-green/40",
  YELLOW: "border-capacity-yellow/40",
  RED: "border-capacity-red/40",
};

